module.exports = __webpack_public_path__ + "static/img/0201_05.f830b42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/02/0201_05.jpg
// module id = gUl+
// module chunks = 1